// A temporary id of a new section, line, block or list item: scribe mints
// the real one on save and returns it.
const TEMP_ID_PREFIX = 'tmp_';

export const createTempId = () =>
  `${TEMP_ID_PREFIX}${crypto.randomUUID().replaceAll('-', '').slice(0, 16)}`;

// Made in this edit, not yet saved.
export const isTempId = (id: string) => id.startsWith(TEMP_ID_PREFIX);
